import { render, staticRenderFns } from "./StockBtn.vue?vue&type=template&id=4a862f0c"
import script from "./StockBtn.vue?vue&type=script&lang=js"
export * from "./StockBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports